//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});

const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);

const href=$(location).attr('href');
let host=	$(location).attr('hostname');
const ref=document.referrer;
const hash=$(location).attr('hash');

if(href.indexOf("/test/")>0)	{
	host=host + "/test";
}

$(document).ready(function(){
	
  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        //$('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeInOutQuart');//smooth
        /*$('html, body').animate({scrollTop: targetOffset/5,opacity: 0}, 300, function() {
					$('html, body').animate({opacity: 1,scrollTop: targetOffset}, 600);
				});//fade scroll*/
        return false;
      }
    }
  });
  
  //Menu
	var state = false;
  var pos;
  $("#menu-btn").on("click",function(){
		if (state == false) {
			pos = $(window).scrollTop();
			$('body').addClass('fixed').css({'top': -pos});
			state = true;
		} else {
			$('body').removeClass('fixed').css({'top': 0});
			window.scrollTo(0, pos);
			state = false;
		}

	  $("#menu").toggleClass("open");
  });
  
  
  //key
	if($(".key").length){
		const keySwiper = new Swiper('.swiper', {
			// オプション設定
			loop: true,
			speed: 800,
			pagination: {
				el: '.swiper-pagination',
				clickable: true, 
			},
			autoplay: { 
				delay: 8000, 
				disableOnInteraction: false, 
			},
			
		});
	}
	
	//dealer-select
	if($(".dealer-select").length){
		var pref = {
			"hokkaido"		:{"北海道":"hokkaido"},
			"tohoku"			:{"青森県":"aomori","岩手県":"iwate","宮城県":"miyagi","秋田県":"akita","山形県":"yamagata","福島県":"fukushima"},
			"hokuriku"		:{"富山県":"toyama","石川県":"ishikawa","福井県":"fukui"},
			"kanto"				:{"茨城県":"ibaraki","栃木県":"tochigi","群馬県":"gunma","埼玉県":"saitama","千葉県":"chiba","東京都":"tokyo","神奈川県":"kanagawa"},
			"koushinetsu"	:{"新潟県":"niigata","山梨県":"yamanashi","長野県":"nagano"},
			"chubu"				:{"岐阜県":"gifu","静岡県":"shizuoka","愛知県":"aichi","三重県":"mie"},
			"kinki"				:{"滋賀県":"shiga","京都府":"kyoto","大阪府":"osaka","兵庫県":"hyogo","奈良県":"nara","和歌山県":"wakayama"},
			"chugoku"			:{"鳥取県":"tottori","島根県":"shimane","岡山県":"okayama","広島県":"hiroshima","山口県":"yamaguchi"},
			"shikoku"			:{"徳島県":"tokushima","香川県":"kagawa","愛媛県":"ehime","高知県":"kochi"},
			"kyushu"			:{"福岡県":"fukuoka","佐賀県":"saga","長崎県":"nagasaki","熊本県":"kumamoto","大分県":"oita","宮崎県":"miyazaki","鹿児島県":"kagoshima","沖縄県":"okinawa"}
		};

		$("#select_area").on("change",function(){
			var area = $(this).val();
			$("#select_pref").html('<option value="" selected="selected">都道府県</option>');
			if(area != ""){
				$.each(pref[area],function(key, value){
					$(".dealer-block").addClass("hidden");
					$("#area_" + area).removeClass("hidden");

					$("#select_pref").append('<option value="#'+value+'">'+key+'</option>');
				});
			}else{
				$(".dealer-block").removeClass("hidden");
			}
		});
		$("#select_pref").on("change",function(){
			var speed = 800;
			var href = $(this).val();
			var target = $(href == "#" || href == "" ? 'html' : href); 
			var position = target.offset().top - $("header").height();
			$('body,html').animate({scrollTop:position}, speed, 'easeOutExpo');
			return false;
		});
	}

	//case map
	if($(".case-map").length){
		$(".case-map .case-map-btn").each(function(){
			let posX = (Number($(this).data("x")) / 1180) * 100;
			let posY = (Number($(this).data("y")) / 750) * 100;
			$(this).css({"left":posX + "%","top":posY + "%","opacity":"1"});
		});


	}
	//faq
	if($(".knowledge-faq").length){
		$(".knowledge-faq-q").eq(0).addClass("open");
		$(".knowledge-faq-a").eq(0).css({"display":"block"});
		
		$(".knowledge-faq-q").on("click",function(){
			$(this).toggleClass("open");
			$(this).next(".knowledge-faq-a").slideToggle();
		})
	}
	//validation
	if($(".form-validation").length){
		$.extend( $.validator.messages, {
			required:'入力してください',
			require_from_group:'入力してください',
			email:'正しいメールアドレスの形式を入力してください',
		});
		if($("body#contact").length){
			var validation = $(".form-validation").validate({
				//debug: true,
				groups: {
					name_group	 : "family_name given_name",
					kana_group	 : "family_kana given_kana",
					zip_group	 : "postal_code3 postal_code4"
				},
				rules: {
					family_name:{ require_from_group : [2, ".group-name"] },
					given_name:{ require_from_group : [2, ".group-name"] },
					family_kana:{ require_from_group : [2, ".group-kana"] },
					given_kana:{ require_from_group : [2, ".group-kana"] },
					postal_code3:{ require_from_group : [2, ".group-zip"] },
					postal_code4:{ require_from_group : [2, ".group-zip"] },
					comment: {required: true},
					tel:{
						required:true,
					},
					email:{
						required:true,
						email:true,
					},
					ckemail:{
						required: true,
						equalTo: '#email',
					},
					address:{required: true},
					organization:{required: true},
					about:{required: true},
				},
				messages:{
					ckemail:{
						required:'確認用のメールアドレスを入力してください',
						equalTo:'確認用メールアドレスが異なります',
					}
				},
				errorPlacement: function(error, element) {
					if (element.attr("name") == "family_name" || element.attr("name") == "given_name") {
						error.insertAfter("#name_group");
					}else if(element.attr("name") == "family_kana" || element.attr("name") == "given_kana"){
						error.insertAfter("#kana_group");
					}else if(element.attr("name") == "postal_code3" || element.attr("name") == "postal_code4"){
						error.insertAfter("#zip_group");
					}else if(element.attr("name") == "about"){
						error.insertAfter("#about_group");
					}  else {
						error.insertAfter(element);
					}
				},
				submitHandler: function(e, r, a) {
					grecaptcha.ready(function() {
						grecaptcha.execute("6Ldhb3UqAAAAAH0aMsRq_RzLgEL5HfmK_z5mbAkX", {
							action: "submit"
						}).then(function(e) {
							const r = document.querySelector("#recaptcha_form"),
								a = document.createElement("input");
							a.type = "hidden", a.name = "recaptcha_response", a.value = e, r.appendChild(a), r.submit()
						})
					})
				}
			});
		}
		if($("body#download").length){
			
			var query=location.search.replace("?","");
			var params = {};
			if(query.length){
				query.split("&").forEach(function (item) {
					var s = item.split("=");
					var k = decodeURIComponent(s[0]);
					var v = decodeURIComponent(s[1]);
					(k in params) ? params[k].push(v) : params[k] = [v];
				});
				var select = params.select[0];
				select.split("-").forEach(function (num) {
					$('.catalog-list [value="' + num + '"]').prop("checked",true);
				});
			}
			var validation = $(".form-validation").validate({
				//debug: true,
				groups: {
					name_group	 : "family_name given_name",
					kana_group	 : "family_kana given_kana",
					zip_group	 : "postal_code3 postal_code4"
				},
				rules: {
					family_name:{ require_from_group : [2, ".group-name"] },
					given_name:{ require_from_group : [2, ".group-name"] },
					family_kana:{ require_from_group : [2, ".group-kana"] },
					given_kana:{ require_from_group : [2, ".group-kana"] },
					postal_code3:{ require_from_group : [2, ".group-zip"] },
					postal_code4:{ require_from_group : [2, ".group-zip"] },
					'catalog[]': {required: true},
					tel:{
						required:true,
					},
					email:{
						required:true,
						email:true,
					},
					ckemail:{
						required: true,
						equalTo: '#email',
					},
					address:{required: true},
					organization:{required: true},
					about:{required: true},
				},
				messages:{
					'catalog[]': {
						required:'ダウンロードするカタログを選択してください',
					},
					ckemail:{
						required:'確認用のメールアドレスを入力してください',
						equalTo:'確認用メールアドレスが異なります',
					}
				},
				errorPlacement: function(error, element) {
					if (element.attr("name") == "family_name" || element.attr("name") == "given_name") {
						error.insertAfter("#name_group");
					}else if(element.attr("name") == "family_kana" || element.attr("name") == "given_kana"){
						error.insertAfter("#kana_group");
					}else if(element.attr("name") == "postal_code3" || element.attr("name") == "postal_code4"){
						error.insertAfter("#zip_group");
					}else if(element.attr("name") == "catalog[]"){
						error.insertAfter(".catalog-text");
					}else if(element.attr("name") == "about"){
						error.insertAfter("#about_group");
					}  else {
						error.insertAfter(element);
					}
				},
				submitHandler: function(e, r, a) {
					grecaptcha.ready(function() {
						grecaptcha.execute("6Ldhb3UqAAAAAH0aMsRq_RzLgEL5HfmK_z5mbAkX", {
							action: "submit"
						}).then(function(e) {
							const r = document.querySelector("#recaptcha_form"),
								a = document.createElement("input");
							a.type = "hidden", a.name = "recaptcha_response", a.value = e, r.appendChild(a), r.submit()
						})
					})
				}
			});
		}
	}
});

function deviceFunc(w){
	const bp = [559,959,1280];
	if(w > bp[1]){ //タブレット以上（PC）

  }else{ //タブレット以下
	
  }
  if (w > bp[0]){//スマートフォン以上
	  $(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  }else{ //スマートフォン以下
	 	$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});	
  }
}
/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}